/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type AiMatchScoreMatchScoreFragment = { lifePlanningMatchingScore: number, onetimeSaleMatchingScore: number, householdImprovementMatchingScore: number, sellingHomeMatchingScore: number, realEstateInvestmentMatchingScore: number, jobChangeMatchingScore: number };

export const AiMatchScoreMatchScoreFragmentDoc = gql`
    fragment AiMatchScoreMatchScore on AiMatchScore {
  lifePlanningMatchingScore
  onetimeSaleMatchingScore
  householdImprovementMatchingScore
  sellingHomeMatchingScore
  realEstateInvestmentMatchingScore
  jobChangeMatchingScore
}
    `;